<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.7071 4.70717C21.0976 4.31664 21.0976 3.68348 20.7071 3.29295C20.3166 2.90243 19.6834 2.90243 19.2929 3.29295L12 10.5858L4.70711 3.29296C4.31658 2.90243 3.68342 2.90243 3.29289 3.29296C2.90237 3.68348 2.90237 4.31664 3.29289 4.70717L10.5858 12.0001L3.29289 19.293C2.90237 19.6835 2.90237 20.3166 3.29289 20.7072C3.68342 21.0977 4.31658 21.0977 4.70711 20.7072L12 13.4143L19.2929 20.7072C19.6834 21.0977 20.3166 21.0977 20.7071 20.7072C21.0976 20.3166 21.0976 19.6835 20.7071 19.293L13.4142 12.0001L20.7071 4.70717Z"
      fill="currentColor"
    />
  </svg>
</template>
